import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'vex-base',
  template: `
    <p>
      base works!
    </p>
  `,
  styles: [
  ]
})
export class BaseComponent implements OnInit {

  constructor(public snackBar: MatSnackBar,
    public translate: TranslateService) { }

  ngOnInit(): void {
    this.hideIntercom();
  }

  hideIntercom() {
    (<any>window).Intercom('update', {
      'hide_default_launcher': true
    });
  }

  showIntercom() {
    (<any>window).Intercom('update', {
      'hide_default_launcher': false
    });
  }

  showSuccess(message: string, action?: string, duration: SnackBarDuration = SnackBarDuration.SHORT) {
    this.snackBar.open(message, action ?? this.translate.instant('SNACKBAR.SUCCESS'), {
      duration: duration == SnackBarDuration.INFINITE ? null : (SnackBarDuration.SHORT ? 2500 : 10000), 
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: 'style-success'
    });
  }

  showError(message: string, action?: string, duration: SnackBarDuration = SnackBarDuration.SHORT) {
    this.snackBar.open(message, action ?? this.translate.instant('SNACKBAR.FAILURE'), {
      duration: duration == SnackBarDuration.INFINITE ? null : (SnackBarDuration.SHORT ? 2500 : 10000), 
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: 'style-failure'
    });
  }

  showWarning(message: string, action?: string, duration: SnackBarDuration = SnackBarDuration.SHORT) {
    this.snackBar.open(message, action ?? this.translate.instant('SNACKBAR.WARNING'), {
      duration: duration == SnackBarDuration.INFINITE ? null : (SnackBarDuration.SHORT ? 2500 : 10000), 
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: 'style-warning'
    });
  }

}

export enum SnackBarDuration {
  LONG, 
  SHORT, 
  INFINITE
}
